import React from "react";
import "./FactureItem.css";
import VerticalPoints from "../../Common/VerticalPoints/VerticalPoints";
import CustomCheckBox from "../../Common/CustomCheckBox/CustomCheckBox";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { getStatusStyle, isDefined } from "../../../Utils";
import { deleteInvoice } from "../../../REDUX/actions/invoices";
import {
  closeCenteredModal,
  openCenteredModal,
} from "../../../REDUX/actions/centeredModal";
import DeleteInvoicesModal from "../Modal/DeleteInvoicesModal";
import { IMAGE_END_POINT } from "../../../Api/EndPoints";
import { saveAs } from "file-saver";
import CommandeStatusTag from "../../Commandes/CommandeStatusTag";
import { getFileName } from "../../../Utils/fileUtils";
import CustomTooltip from "../../Common/CustomTooltip/CustomTooltip";
import { openRightModal } from "../../../REDUX/actions/rightModal";
import InvoiceComments from "../InvoicesComments";
import adjustPrice from "../../../Utils/AdjustPrice";
import { useTranslation } from "react-i18next";

function FactureItem({
  id,
  type,
  orderID,
  reseller,
  refClient,
  realRefClient,
  createdAt,
  oldCreatedAt,
  attachment,
  totalTTC,
  checked,
  searchInput,
  setCheckedInvoices,
  fileUrl,
  status,
  oldId,
  oldIdOrder,
  slug,
  slugDate,
  orderSlug,
  checkedInvoices,
}) {
  const { t } = useTranslation("common");
  const { user, userRole } = useSelector((state) => state.userReducer);
  const dispatch = useDispatch();

  const openDeleteModal = (action, message) => {
    dispatch(
      openCenteredModal(
        <DeleteInvoicesModal handleDelete={action} message={message} />
      )
    );
  };
  const handleDelete = () => {
    dispatch(deleteInvoice({ id, type, searchInput }));
    dispatch(closeCenteredModal());
  };
  const handleClick = () => {
    // setChecked(!checked);
    if (checked) {
      setCheckedInvoices((currItems) =>
        currItems?.filter((item) => +item?.id !== +id)
      );
    } else {
      setCheckedInvoices((currItems) => [
        ...currItems,
        {
          id,
          fileUrl,
          orderSlug,
          invoiceSlug: slug,
          type,
        },
      ]);
    }
  };

  const detailsOptionsAdmin = [
    {
      text: t("Download invoice"),
      callback: () =>
        saveAs(
          `${IMAGE_END_POINT}${fileUrl}`,
          getFileName({
            url: fileUrl,
            srcSlug: orderSlug,
            fileSlug: slug,
            type: { fileName: "Facture", src: "Commande" },
          })
        ),
      hidden: !fileUrl,
    },
    {
      text: t("Comment"),
      callback: () =>
        dispatch(openRightModal(<InvoiceComments id={id} slug={slug} />)),
      hidden: type === "acompte-facture",
    },
    {
      text: t("Delete the invoice"),
      red: true,
      callback: () =>
        openDeleteModal(
          handleDelete,
          t("Are you sure you want to delete these invoices?")
        ),
    },
  ];

  const detailsOptions = [
    {
      text: t("Download invoice"),
      callback: () =>
        saveAs(
          `${IMAGE_END_POINT}${fileUrl}`,
          getFileName({
            url: fileUrl,
            srcSlug: orderSlug,
            fileSlug: slug,
            type: { fileName: "Facture", src: "Commande" },
          })
        ),
      hidden: !fileUrl,
    },
    {
      text: t("Comment"),
      callback: () =>
        dispatch(openRightModal(<InvoiceComments id={id} slug={slug} />)),
      hidden: type === "acompte-facture",
    },
  ];

  const getOptionsBasedOnUserRole = (userRole) => {
    if (userRole === "BusinessBroker" || userRole === "reseller") {
      return detailsOptions;
    } else if (userRole === "admin") {
      return detailsOptionsAdmin;
    } else return [];
  };

  const factureColWidth = user?.attributes?.userRole === 0 ? "w14" : "w14";
  const factureColStyle = `f14 text-brightGrey mb-0 ${factureColWidth}`;
  const checkedClassName = checked ? "checked" : "";

  return (
    <div
      className={`factureItem d-flex align-items-center b-1-bottom-softGrey p-3 pointer ${checkedClassName}`}
      role="button"
      onClick={handleClick}
    >
      <CustomCheckBox checked={checked} className="me-3" />
      <CustomTooltip title={t("#New|Old")}>
        <p className={factureColStyle}>
          {/* {isDefined(oldId) ? `#${slug}/${oldId}` : `#${slug}`} */}
          {`#${slug}`}
        </p>
      </CustomTooltip>
      <CustomTooltip title={t("#New|Old")}>
        <p className={factureColStyle}>
          {oldIdOrder || orderSlug
            ? oldIdOrder
              ? `#${orderSlug}/${oldIdOrder}`
              : `#${orderSlug}`
            : "-"}
        </p>
      </CustomTooltip>
      {/* <p className={factureColStyle}>{orderID ? `#${orderID}` : "-"} </p> */}
      {/* <p className={factureColStyle}>{refClient}</p> */}
      {/* <p className={factureColStyle}>{realRefClient ?? "-"}</p> */}
      {user?.attributes?.userRole !== 0 && (
        <p className={`f14 text-softBlue mb-0 ${factureColWidth}`}>
          {reseller ?? "-"}
        </p>
      )}

      <p className={factureColStyle}>{moment(slugDate).format("DD-MM-YYYY")}</p>
      <p className={factureColStyle}>
        {totalTTC ? `${adjustPrice(totalTTC.toFixed(2).toString())} €` : "-"}
      </p>

      <div className="col-1">
        <span className=" d-inline-block w-100 f14 text-brightGrey">
          {t(`${status ?? ""}`) ?? "-"}
          {/* <CommandeStatusTag status={status} /> */}
        </span>
      </div>
      <VerticalPoints
        options={getOptionsBasedOnUserRole(userRole)}
        showLeft
        className="ms-auto"
      />
    </div>
  );
}

export default FactureItem;
